import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import * as React from 'react';

import Layer from '../models/Layer';

export interface Props {
  onLayerToggle: (layerId: string) => void;

  layer: Layer;
}

const MapLayer: React.FC<Props> = ({ onLayerToggle, layer: { key, title, isChecked } }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox checked={isChecked} onChange={onLayerToggle.bind(null, key)} value={title} />
      }
      label={title}
    />
  );
};

export default MapLayer;
